module.exports = __webpack_public_path__ + "static/media/loading.4d1b04c3.svg";